import {
  ActionTypes,
  ILayerInput,
  IGetLayersRequestReturn,
  IGetLayersSuccessReturn,
  ILayersState,
} from './types';

export function getLayersRequest(input: ILayerInput): IGetLayersRequestReturn {
  return {
    type: ActionTypes.getLayersRequest,
    payload: {
      input,
    },
  };
}

export function getLayersSuccess(input: ILayersState): IGetLayersSuccessReturn {
  return {
    type: ActionTypes.getLayersSuccess,
    payload: {
      input,
    },
  };
}

export function getLayersFailure(input: ILayersState): any {
  return {
    type: ActionTypes.getLayersFailure,
    payload: {
      input,
    },
  };
}
